import { INSTANT_SETTLEMENT_VERSION } from '@app/dashboard/constants/balance_and_transfers/balance/modals';
import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

import type {
  ICalculateInstantSettlementFeesPayload,
  ISubmitInstantSettlementPayload,
} from '@app/dashboard/types/innerLayout/balance_and_transfers/balance/instant-settlement';

export const getBalanceTypes = () => {
  return axiosPrivate.get('/instantsettlement/settlement_balance/', {
    params: { version: INSTANT_SETTLEMENT_VERSION },
  });
};

export const calculateInstantSettlementFees = (
  payload: ICalculateInstantSettlementFeesPayload
) => {
  return axiosPrivate.post(
    '/instantsettlement/final_settlement_details/',
    payload
  );
};

export const submitInstantSettlement = (
  payload: ISubmitInstantSettlementPayload
) => {
  return axiosPrivate.post(
    '/instantsettlement/bank_instant_settlement/',
    payload
  );
};
